export const languageToFlag = {
	English: "gb", // or "us" if you prefer 🇺🇸
	Spanish: "es",
	Catalan: "es", // or "ad" for Andorra 🇦🇩
	French: "fr",
	German: "de",
	Portuguese: "pt",
	Italian: "it",
	Polish: "pl",
	Russian: "ru",
	Mandarin: "cn",
	Japanese: "jp",
	Korean: "kr",
	Hindi: "in",
	Arabic: "sa",
	Bengali: "bd",
};
export const supportedLanguages = Object.keys(languageToFlag);

export const conversationSubjects = ["userData", "travel", "current news", "technology"];
